
import { uniqueId } from 'lodash'
import Popper from 'popper.js'

export default {
  name: 'Popover',

  props: {
    config: {
      type: Object,
      default: () => ({
        placement: 'bottom'
      })
    },

    closeOnClickOutside: {
      type: Boolean,
      default: true
    },

    popoverOnHover: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      id: null,
      hoverElement: null,
      isOpen: false,
      dataTrigger: null,
      dataPopper: null
    }
  },

  watch: {
    isOpen(isOpen) {
      this.$emit('is-open', isOpen)
    }
  },

  created() {
    // Unique ID has to be generated on mounted otherwise it will be different when hydrated vs SSR
    this.id = uniqueId('popover-')
  },

  mounted() {
    this.setup()
  },

  beforeDestroy() {
    if (!this.popover) {
      return
    }

    if (this.closeOnClickOutside) {
      document.removeEventListener('click', this.close)
    }

    if (this.popoverOnHover) {
      if (this.hoverElement) {
        this.hoverElement.removeEventListener('mouseenter', this.open)
        this.hoverElement.removeEventListener('mouseleave', this.close)
      }
    }

    this.popover.destroy()
  },

  methods: {
    async setup() {
      this.dataTrigger = this.$el.querySelector('[data-popover-trigger], .popover-trigger')

      this.dataPopper = this.$el.querySelector('[data-popover-popper]')

      if (this.closeOnClickOutside) {
        document.addEventListener('click', this.close)
      }

      await this.$nextTick()

      if (this.popoverOnHover) {
        this.hoverElement = document.getElementById(this.id)

        if (this.hoverElement) {
          this.hoverElement.addEventListener('mouseenter', this.open, false)
          this.hoverElement.addEventListener('mouseleave', this.close, false)
        }
      }
    },

    toggle() {
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.open()
      }
    },

    open() {
      this.isOpen = true

      this.setupPopper()
    },

    close(clickEvent = null) {
      if (!this.isOpen) {
        return
      }

      if (clickEvent && this.$el.contains(clickEvent.target) && clickEvent.type !== 'mouseleave') {
        return false
      }

      this.isOpen = false
    },

    async setupPopper() {
      await this.$nextTick()

      if (this.dataPopper === null) {
        return
      }

      if (this.popover === undefined) {
        const config = { ...this.config }

        if (config.modifiers === undefined) {
          config.modifiers = {
            offset: {
              enabled: true,
              offset: '0 5px'
            }
          }
        }

        this.popover = new Popper(this.dataTrigger, this.dataPopper, config)
      } else {
        this.popover.scheduleUpdate()
      }
    }
  }
}
